import { CountList } from '../invoice/InvoiceSummaryParts';

export interface TotalsMetric {
    label: string;
    value: React.ReactNode;
    emphasis?: boolean;
}

interface Props {
    counts: TotalsMetric[];
    natures: Record<string, number>;
    amounts: TotalsMetric[];
}

const Metric: React.FC<{ metric: TotalsMetric }> = ({ metric }) => (
    <span className="inline-flex items-center gap-1 whitespace-nowrap">
        <span className="text-gray-500 dark:text-gray-400">{metric.label}</span>
        <strong className={`text-gray-900 dark:text-gray-100 ${metric.emphasis ? 'text-sm' : ''}`}>{metric.value}</strong>
    </span>
);

const PageTotalsBar: React.FC<Props> = ({ counts, natures, amounts }) => (
    <div role="region" aria-label="Totais da página"
        className="relative z-[1] flex flex-wrap items-center gap-x-5 gap-y-1 px-3 py-2 text-xs border-x border-b bg-gray-50 dark:bg-slate-900 dark:border-slate-700 shadow-[0_-4px_6px_-2px_rgba(0,0,0,0.08)] dark:shadow-[0_-4px_8px_-2px_rgba(0,0,0,0.6)]">
        <span className="font-semibold text-gray-600 dark:text-gray-300">Nesta página</span>
        {counts.map(metric => <Metric key={metric.label} metric={metric} />)}
        <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <span className="text-gray-500 dark:text-gray-400">Natureza</span>
            <CountList counts={natures} />
        </span>
        <span className="flex-1" />
        {amounts.map(metric => <Metric key={metric.label} metric={metric} />)}
    </div>
);

export default PageTotalsBar;
